import type { Key } from "./dictionary";
import { arScreens } from "./dictionary.ar.screens";
import { balootAr } from "./dictionary.baloot";
import { cardAr } from "./dictionary.card";
import { heartsAr } from "./dictionary.hearts";
import { homeAr } from "./dictionary.home";
import { kingAr } from "./dictionary.king";
import { languageAr } from "./dictionary.language";
import { matchAr } from "./dictionary.match";
import { pistiAr } from "./dictionary.pisti";
import { rulesAr } from "./dictionary.rules";
import { socialAr } from "./dictionary.social";
import { spadesAr } from "./dictionary.spades";
import { tablesAr } from "./dictionary.tables";

/**
 * Arabic (review 0021): Modern Standard Arabic with the words players use at the table (decision
 * 130), Western digits (131). A draft until a native Gulf player reviews it (135); every English
 * key and placeholder is required (tested). Plurals name CLDR categories.
 */
// Split in two files for the file budget; the dictionary test checks every key is here.
export const ar = {
  ...matchAr,
  ...balootAr,
  ...spadesAr,
  ...cardAr,
  ...languageAr,
  ...socialAr,
  ...rulesAr,
  ...heartsAr,
  ...homeAr,
  ...kingAr,
  ...pistiAr,
  ...tablesAr,
  ...arScreens,
  "app.name": "High Card Club",
  "table.bar.trump": "الحكم {suit}",
  "table.bar.trumpLabel": "الحكم",
  "table.bar.targetLabel": "إلى",
  "table.bar.handsLabel": "الجولات",
  "table.turn.you": "دورك",
  "table.turn.play": "دورك · العب",
  "table.turn.other": "{name} يلعب",
  "table.turn.bidding": "{name} يزايد",
  "table.turn.trump": "{name} يختار الحكم",
  "table.bid.you": "دورك في المزايدة",
  "table.trump.forHand": "مقابل {amount} {amount|one:أكلة|two:أكلتين|few:أكلات|other:أكلة}",
  "table.trump.inHand": "{count} في يدك",
  "table.seat.pass": "باس",
  "table.seat.thinking": "يفكر…",
  "table.seat.waiting": "بانتظار",
  "table.seat.score": "{score} نقطة",
  "table.seat.away": "غائب · البوت يلعب",
  "table.seat.hand": "في يده {count} ورقة",
  "table.trick.led": "{name} بدأ",
  "table.handEnd.title": "انتهت الجولة",
  "table.event.redeal": "الجميع قال باس: توزيع جديد",
  "table.event.contract-forced": "الجميع قال باس: {name} يلعب {amount}",
  "table.event.trump-chosen": "الحكم {suit}",
  "table.bar.noTrump": "بدون حكم",
  "table.seat.chooseTrump": "زايد {amount} · اختر الحكم",
  "table.bid.canSay": "{name} زايد {amount} · يمكنك {min} أو أكثر",
  "table.bid.open": "لا مزايدة بعد · يمكنك {min} أو أكثر",
  "table.bid.note": "إذا قال الجميع باس، يلعب أول المتكلمين 4",
  "table.toast.points": "{points} نقطة",
  "table.toast.down": "خسر الطلب · {points} نقطة",
  "table.toast.won": "فزت بالطلب على {amount}",
  "table.toast.pickTrump": "اختر الحكم الآن",
  "table.toast.forced": "الجميع قال باس: أنت تلعب {amount}",
  "table.gameEnd.meta": "{hands} {hands|one:جولة|two:جولتان|few:جولات|other:جولة} · {target}",
  "table.watching.sub": "· يفرغ مقعد عند انتهاء المباراة",
  "table.connecting.sub": "مقعدك محفوظ؛ يلعب بوت عنك حتى تعود.",
  "table.leaving": "جارٍ مغادرة الطاولة…",
  "table.bar.hand": "الجولة {hand}",
  "table.bar.goal": "إلى {goal}",
  "table.bar.length": "من {length}",
  "table.seat.tricks": "{tricks} {tricks|one:أكلة|two:أكلتان|few:أكلات|other:أكلة}",
  "table.seat.bid": "طلب {amount}",
  "table.seat.turn": "دوره",
  "table.bid.title": "مزايدتك",
  "table.bid.pass": "باس",
  "table.trump.title": "اختر الحكم",
  "table.hand.title": "أوراقك",
  "table.watching": "أنت تشاهد",
  "table.handEnd.made": "{name} طلب {amount} وجابها",
  "table.handEnd.failed": "{name} طلب {amount} وخسر",
  "table.gameEnd.title": "انتهت المباراة",
  "table.gameEnd.winner": "الفائز: {names}",
  "table.again": "العب مرة أخرى",
  "table.leave": "غادر الطاولة",
  "table.trick.winner": "{name} أخذ الأكلة",
  "table.connecting": "جارٍ إعادة الاتصال…",
  "table.event.contract-won": "{name} فاز بالطلب على {amount}",
  "suit.spades": "بستوني",
  "suit.hearts": "كبة",
  "suit.diamonds": "ديناري",
  "suit.clubs": "سباتي",
} as Record<Key, string>;
